<template>
    <div>
      <h2>Welcome to the Invoice Application</h2>
      <router-link to="/dashboard">Dashboard</router-link><br/>
      <router-link to="/about-me">About Me</router-link><br/>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent } from 'vue'
  import { useAuthStore } from '@/stores/authStore'
   import { useRouter } from 'vue-router'
  
  export default defineComponent({
    setup() {
      const authStore = useAuthStore()
      const router = useRouter()

      if(authStore.getRole == 'Admin')
        {
            router.push('/admin')
        }
        else
        {
            router.push('/user')
        }
  
      return {
      }
    },
  })
  </script>
  